import { AxiosRequestConfig } from "axios";

import api from "@services/axios/originacao";

import { ICustomApiOptions, useApi } from "./useApi";

export function useApiOriginacao<T, D = unknown, E = unknown>(
  baseConfig: AxiosRequestConfig<D>,
  customConfig?: ICustomApiOptions,
) {
  return useApi<T, D, E>(
    api,
    {
      ...baseConfig,
      headers: {
        ...baseConfig.headers,
        "X-Amigoz-digitacao": "originacao",
      },
    },
    customConfig,
  );
}
